import { render, staticRenderFns } from "./materialTableEl.vue?vue&type=template&id=17f2f29c&scoped=true"
import script from "./materialTableEl.vue?vue&type=script&lang=js"
export * from "./materialTableEl.vue?vue&type=script&lang=js"
import style0 from "./materialTableEl.vue?vue&type=style&index=0&id=17f2f29c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f2f29c",
  null
  
)

export default component.exports